module.exports = __webpack_public_path__ + "static/media/institutions-square.84d7bfc5.jpg";